<template>
    <div class="obras container">
        <h2 class="text-center">Actividades de Escaparatismo</h2>
        <hr>
        <div class="row d-flex justify-content-center">
            <div class="col-md-12">
                 <h4>Fundamento</h4>
             <p class="studio-p"> Los escaparates son nuestra carta de presentación a todas las personas que pasan frente a nuestro local, una invitación a conocernos,
                  a ver lo que nuestra marca puede ofrecerle, un mensaje que queremos trasmitir para conectar con nuestro público. 
                  Es imposible medir el gran alcance que tiene, por ello debe estar bien presentado siempre!.</p>
            </div>
        </div>
       <div class="row">
           <div v-for="(item,i) in items" :key="i"   class="col-md-3">
               <router-link v-if="item.activo == 'activo'" :to="`/curso/curso/${item.id}`" tag="a" class="box-studio text-center">
                   <a href="">{{item.titulo}}</a>
               </router-link >
               <div v-else class="box-studio text-center">
                     <div class="no-link">{{item.titulo}}</div>
               </div>
           </div>  
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            items:[]
        }
    },
    methods:{
        loadLogs () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/cursos/rows?filters[tipo][in]=escaparatismo`)
        .then(function (data) {
            console.log(data.body.data);
            this.items = data.body.data;
      
        })
      }
    },
      mounted () {
        this.$nextTick(function () {
        this.loadLogs();
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cursos/Escaparatismo.vue